<template>
  <div class="tabs" :class="{ disabled: disabled }" id="filter-tabs">
    <div class="tab btn" @click="update('1')">
      <div class="copy">{{ $t("gateTab.enabled") }}</div>
      <span class="mdi mdi-check-circle-outline"></span>
    </div>
    <div class="tab btn" @click="update('0')">
      <div class="copy" >{{ $t("gateTab.disabled") }}</div>
      <span class="mdi mdi-close-circle-outline"></span>
    </div>
    <div class="tab btn" @click="update('all')" :class="{ active: value }">
      <div class="copy">{{ $t("gateTab.all") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GateTabs',
  props: {
    tabs: Array,
    value: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    update(value) {
      var header = document.getElementById('filter-tabs');
      var btns = header.getElementsByClassName('btn');
      for (var i = 0; i < btns.length; i++) {
        btns[i].addEventListener('click', function () {
          var current = document.getElementsByClassName('active');
          current[0].className = current[0].className.replace(' active', '');
          this.className += ' active';
        });
      }
      this.$emit('update', value);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.active {
  color: $general-white;
  background-color: $brand-primary-button;
}
.tabs {
  width: 100%;
  height: 35px;
  position: relative;
  cursor: pointer;
  border-radius: 3px;
  text-align: center;
  background-color: $general-white;
  border: solid 1px $brand-primary-button;
  color: $brand-primary-button;

  display: flex;
  align-items: center;
  justify-content: center;

  &.disabled {
    pointer-events: none;
    color: $brand-primary-button-disabled;
    border: solid 1px $brand-primary-button-disabled;
  }

  .tab {
    width: auto;
    height: 100%;
    position: relative;
    padding: 0 20px;
    border-right: solid 1px $brand-primary-button;

    display: flex;
    align-items: center;
    justify-content: center;

    &:last-child {
      border-right: none;
    }

    &:hover {
      background-color: $brand-tertiary-button-hover;
    }

    &.active {
      color: $general-white;
      background-color: $brand-primary-button;
    }

    .copy {
      width: auto;
      position: relative;
      font-size: 12px;
      font-weight: 700;
      text-align: center;
    }

    .icon {
      width: auto;
      height: auto;
      font-size: 18px !important;
      margin-left: 10px;
    }
  }

  &.disabled .tab {
    border-right: solid 1px $brand-primary-button-disabled;
  }

  &.disabled .tab.active {
    color: $general-white;
    background-color: $brand-primary-button-disabled;
  }
}
</style>
